import fogUrl from '@/assets/svg/fog.svg';
import type { Visibility } from '@/types/weather';

interface Props {
  fog: Visibility;
}

const FOG_BANDS = [
  { top: 35, opacity: 0.7, delay: 0, duration: 18 },
  { top: 50, opacity: 0.55, delay: -6, duration: 24 },
  { top: 65, opacity: 0.45, delay: -12, duration: 20 },
  { top: 80, opacity: 0.35, delay: -4, duration: 28 },
];

export function FogLayer({ fog }: Props) {
  const visible = fog !== 'clear';
  const baseOpacity = fog === 'fog' ? 1 : 0.5;

  return (
    <div
      className="layer"
      style={{
        zIndex: 40,
        opacity: visible ? baseOpacity : 0,
        transition: 'opacity 4s ease-in-out',
      }}
    >
      {FOG_BANDS.map((band, i) => (
        <img
          key={i}
          src={fogUrl}
          alt=""
          style={{
            position: 'absolute',
            top: `${band.top}%`,
            left: '-5%',
            width: '110%',
            opacity: band.opacity,
            animationName: 'fogDrift',
            animationDuration: `${band.duration}s`,
            animationDelay: `${band.delay}s`,
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
          }}
        />
      ))}
    </div>
  );
}
